var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"Layer 1"},[React.createElement("path",{"fill":"none","d":"M0 0h16v16H0z","key":0}),React.createElement("path",{"d":"M5.172.929l5.656 5.657L12.243 8l-1.415 1.414-5.656 5.657-1.415-1.414L9.414 8 3.757 2.343 5.172.929z","key":1})])));
}

ChevronRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
